// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2osjO","head":"ProcedureTableInfo_head__3vdv8"};